
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/solar-finance",
      function () {
        return require("private-next-pages/integrations/solar-finance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/solar-finance"])
      });
    }
  